import { register, attachScripts, getPrefix } from '../../../Utils'
import * as constants from '../../../../../../designTokens.json'

const MediaGallery = el => {
}

register('MediaGallery', MediaGallery)
